module.exports = {"431121001":"龙山街道","431121002":"长虹街道","431121003":"浯溪街道","431121101":"观音滩镇","431121102":"茅竹镇","431121103":"大忠桥镇","431121104":"三口塘镇","431121105":"肖家镇","431121106":"八宝镇","431121107":"白水镇","431121108":"黄泥塘镇","431121109":"进宝塘镇","431121110":"潘市镇","431121111":"梅溪镇","431121112":"羊角塘镇","431121113":"下马渡镇","431121114":"七里桥镇","431121115":"大村甸镇","431121116":"黎家坪镇","431121117":"文富市镇","431121118":"文明铺镇","431121119":"龚家坪镇","431121401":"原种场","431121402":"畜牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431121.json
// module id = 2030
// module chunks = 0